var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-linear',{attrs:{"color":_vm.getStatus.color,"height":"20","value":_vm.value},scopedSlots:_vm._u([{key:"default",fn:function({ value }){return [_c('strong',{attrs:{"color":_vm.getStatus.textColor}},[_vm._v(_vm._s(Math.ceil(value))+"%")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }